<template>
  <span class="" id="mouse-position"></span>
</template>

<script>

import MousePositionControl from 'ol/control/MousePosition'
import { format, toStringHDMS } from 'ol/coordinate'

const coordFormats = [
  {
    projection: 'EPSG:4326',
    srname: 'WGS',
    coordinateFormat: (coordinate) => {
      return format(coordinate, 'N: {y} E: {x}', 4)
    }
  },
  {
    projection: 'EPSG:4326',
    srname: 'WGS dms',
    coordinateFormat: (coordinate) => {
      return toStringHDMS(coordinate, 1)
    }
  },
  {
    projection: 'EPSG:3301',
    srname: 'L-EST',
    coordinateFormat: (coordinate) => {
      return format(coordinate, '{y}, {x}', 0)
    }
  }
]

export default {
  data: () => ({
    format: 0,
    control: null
  }),
  mounted () {
    this.control = new MousePositionControl({
      coordinateFormat: coordFormats[this.format].coordinateFormat,
      projection: coordFormats[this.format].projection,
      className: 'float-left coords',
      target: 'mouse-position',
      undefinedHTML: ''
    })
    this.$map.addControl(this.control)
  }
}
</script>

<style lang="stylus">
#mouse-position
  font-family: "Helvetica Neue",Helvetica,Arial,sans-serif
  color: white
  font-size: 12px
  div.coords
    position: relative
    display: inline-block
</style>
